<template>
  <v-container fluid>
    <v-layout>
      <v-container>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Update Entity</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-text-field
                v-model="entity.Uuid"
                label="UUID"
                hint="UUID of the entity"
                outline
                readonly
              ></v-text-field>

              <v-switch
                v-model="entity.Entity_Status"
                :label="`ACTIVE ENTITY`"
              ></v-switch>

              <v-text-field
                v-model="entity.Entity_Name"
                label="Name"
                :rules="[v => !!v || 'Please specify a name for the entity']"
                data-vv-name="name"
                hint="Name of the Entity"
                required
                outline
              ></v-text-field>

              <v-select
                v-model="entity.Tags"
                :items="possibleTags"
                attach
                outline
                chips
                label="Tags"
                color="purple"
                multiple
              ></v-select>

              <v-textarea
                name="input-7-1"
                v-model="entity.Search_Query"
                label="Entity Query"
                :rules="[v => !!v || 'Please specify a query']"
                required
                hint="Query for filtering relevant results for this entity"
                outline
              ></v-textarea>

              <v-textarea
                name="input-7-1"
                v-model="entity.Additional_AND_NOTs_for_Reprocessings"
                label="Additional AND NOTs for Reprocessings"
                hint="AND NOTs used on fragments"
                outline
              ></v-textarea>

              <v-select
                v-model="entity.Country_Code"
                :items="countryCodes"
                attach
                outline
                chips
                hint="Country to which this entity belongs mainly"
                label="Country Code"
                color="purple"
                multiple
                required
                :rules="[(v) =>  v.length>0 || 'Please provide at least one country code']"
              ></v-select>

            </v-card-text>
          </v-card>

          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Chinese String Replacement (For Chinese Entities Only!)</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-layout row>
                <v-flex xs6>
                  <v-textarea
                    name="chinese-string"
                    v-model="chineseStringDisplay"
                    label="Chinese String"
                    hint="Chinese characters for search query (comma-separated for multiple values)"
                    outline
                    rows="2"
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    name="latin-replacement"
                    v-model="entity.Latin_Replacement"
                    label="Latin Letter Replacement"
                    hint="Latin letters that replace the Chinese string"
                    outline
                    rows="2"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Industries / Branchen</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-select
                v-model="entity.Industry_1"
                :items="industries_1"
                attach
                outline
                chips
                clearable
                label="Industry 1 / Branche 1"
                color="purple"
              ></v-select>

              <v-select
                v-model="entity.Industry_2"
                :items="industries_2"
                attach
                outline
                chips
                clearable
                label="Industry 2 / Branche 2"
                color="purple"
              ></v-select>

              <v-select
                v-model="entity.Industry_Final"
                :items="industries_final"
                attach
                outline
                chips
                clearable
                label="Industry Final / Branche Final"
                color="purple"
              ></v-select>

              <v-select
                v-model="entity.Industries_Austria"
                :items="industries_austria"
                attach
                outline
                chips
                label="Industries_Austria"
                color="purple"
                multiple
              ></v-select>
 
              <v-select
                v-model="entity.Industries_Switzerland"
                :items="industries_switzerland"
                attach
                outline
                chips
                clearable
                label="Industry Switzerland"
                color="purple"
              ></v-select>
                           
            </v-card-text>
          </v-card>
          <v-card v-if="ubermetricsAccount === null">
            <v-card-text>
              <v-alert
                :value="true"
                type="warning"
              >
                There is no current search in Ubermetrics defined. Please specify a Ubermetrics search.
              </v-alert>
            </v-card-text>
          </v-card>
          <v-card v-if="ubermetricsAccount !== null">     
            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Current Ubermetrics Search</v-toolbar-title>
            </v-toolbar>          
          </v-card>
                      
          <v-card  v-for="item in entity.Account_Search_Ids_New" :key="item" v-if="ubermetricsAccount !== null">

            
            <v-card-text>

              <div v-if="item.search">
                <span class="headline">Name: {{ item.search.name }} </span>
              </div>

              <v-chip color="green" text-color="white">
                <v-avatar class="teal">{{ item.value.split("_")[0] }}</v-avatar>
                UM Account
              </v-chip>
              <v-chip color="green" text-color="white">
                <v-avatar class="teal">{{ item.value.split("_")[1] }}</v-avatar>
                UM Search
              </v-chip>
              <v-btn round color="primary"
                     :to="{ name: 'ubermetrics_search_edit', params: { id: item.value}}">
                Edit Search
                <v-icon right dark>edit</v-icon>
              </v-btn>
              <v-switch
                v-model="item.remove"
                :label="`Remove search from entity`"
              ></v-switch>
            </v-card-text>

          </v-card>
          <v-card>
            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Add Ubermetrics Search</v-toolbar-title>
            </v-toolbar>
            <v-card-text>

              <v-autocomplete
                v-model="ubermetricsSearchSelect"
                :items="ubermetricsSearches"
                :search-input.sync="search"
                :rules="ubermetricsSearchRules"
                outline
                cache-items
                hide-no-data
                no-filter
                hint="Search for an Ubermetrics Search which is the source for this entity"
                item-text="Detail_Info"
                item-value="Unique_Id"
                label="Existing Ubermetrics Searches"
                placeholder="Start typing to Search"
              ></v-autocomplete>

            </v-card-text>

          </v-card>
          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Event Types Mapping</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-select
                v-model="entity.Event_Regex"
                :items="eventRegexTypes"
                attach
                outline
                item-text="id"
                item-value="id"
                chips
                label="Use special Event Regex"
                color="purple"
                multiple
              ></v-select>

            </v-card-text>
          </v-card>
          
            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Kununu Links</v-toolbar-title>
            </v-toolbar>
                                 
          <v-card>
          <div
          v-for="(input, index) in entity.Kununu_Links"
          :key="`kununuInput-${index}`"
          class="input wrapper flex items-center"
          >
          <v-card-text>
            <!--          Remove Svg Icon-->
            <svg
              v-show="entity.Kununu_Links.length > 0"
              @click="removeField(index, entity.Kununu_Links)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              class="ml-2 cursor-pointer"
            >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="#EC4899"
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
            />
            </svg>        
            <v-text-field
                v-model="entity.Kununu_Links[index]"
                label="Kununu-Link"
                hint="a kununu link"
                outline/>
          </v-card-text>          
          </div>
          <v-card-text>
            <v-btn @click="addField(input, entity.Kununu_Links)" large>+ Add Kununu Link</v-btn>
          </v-card-text>                      
          </v-card>   

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Twitter Authors</v-toolbar-title>
            </v-toolbar>          
          <v-card>
          <div
          v-for="(input, index) in entity.Twitter_Authors"
          :key="`twitterInput-${index}`"
          class="input wrapper flex items-center"
          >
          <v-card-text>
            <!--          Remove Svg Icon-->
            <svg
              v-show="entity.Twitter_Authors.length > 0"
              @click="removeField(index, entity.Twitter_Authors)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              class="ml-2 cursor-pointer"
            >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="#EC4899"
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
            />
            </svg>        
            <v-text-field
                v-model="entity.Twitter_Authors[index]"
                label="Twitter-Author"
                hint="a twitter author"
                outline/>
          </v-card-text>          
          </div>
          <v-card-text>
            <v-btn @click="addField(input, entity.Twitter_Authors)" large>+ Add Twitter Author</v-btn>
          </v-card-text>                      
          </v-card>   
                                  
          <v-card>
            <v-toolbar
              card
              color="grey lighten-3">
              <v-toolbar-title>Validation</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-form
                ref="testinput_form"
              >
                <v-text-field
                  v-model="testInput"
                  label="Test Input Data"
                  hint="Enter some test string to see if the pattern is matching"
                  loading
                >
                  <v-progress-linear
                    slot="progress"
                    :value="progress"
                    :color="testInputColor"
                    height="7"
                  ></v-progress-linear>

                </v-text-field>

              </v-form>

            </v-card-text>

          </v-card>
          <v-card>
            <v-toolbar
              card
              color="grey lighten-3">
              <v-toolbar-title>Regex Checks</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-textarea
                label="Regex from Ubermetrics Search"
                v-model="Regex_from_Ubermetrics_search"
                outline
                rows="1"
                auto-grow
                readonly
              ></v-textarea>
              <v-textarea
                label="Pattern Definitions"
                v-model="Pattern_Definitions"
                rows="1"
                outline
                auto-grow
                readonly
              ></v-textarea>
              <v-textarea
                label="Regex for Processing"
                v-model="Regex_for_Processing"
                rows="1"
                outline
                auto-grow
                readonly
              ></v-textarea>
              <v-btn @click="submit" color="error" large>Save Entity</v-btn>
              <v-btn @click="cancel">Cancel</v-btn>

            </v-card-text>

            <v-card-text>
              <v-text-field
                v-model="entity.Update_Note"
                label="Update Note"
                placeholder="Needs update because of ..."
                hint="Describe your update. E.g. why has it been deactivated? "
                outline/>
            </v-card-text>

            <v-snackbar
              v-model="snackbar"
              :multi-line="true"
              :timeout="6000"
              :top="true"
              :vertical="true"
            >
              {{ text }}
              <v-btn
                color="pink"
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>

          </v-card>
        </v-form>
 
        <v-card>
          <v-list v-if="entity.revisions.length > 0"
                  three-line>
            <template v-for="(revision, index) in entity.revisions">
              <v-list-tile
                avatar
                ripple
              >
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-chip color="primary" text-color="white" v-if="revision.UpdatedAt">
                      <v-icon left>schedule</v-icon>
                      <strong>{{ revision.UpdatedAt }}</strong>
                      <span>&nbsp;(Updated)</span>
                    </v-chip>
                    <v-chip color="primary" text-color="black" outline v-else>
                      <strong>{{ revision.Imported_At }}</strong>
                      <span>&nbsp;(Import Time)</span>
                    </v-chip>
                    <template v-for="(item, index) in revision.Account_Search_Ids">
                      <v-chip color="primary" text-color="black" outline v-if="revision.Ubermetrics_Account_Id">
                        <strong>{{ item.split('_')[0] }} / {{ item.split('_')[1] }}</strong>
                      </v-chip>
                    </template>
                    <v-chip color="green darken-3" text-color="green darken-3" outline
                            v-if="revision.Entity_Status === null || revision.Entity_Status === true">
                      <v-avatar>
                        <v-icon>check_circle</v-icon>
                      </v-avatar>
                      Active
                    </v-chip>
                    <v-chip color="red darken-4" text-color="red darken-4" outline v-else>
                      <v-avatar>
                        <v-icon>block</v-icon>
                      </v-avatar>
                      Inactive
                    </v-chip>
                    <v-chip v-for="revisionTag in revision.Tags" :key="revisionTag" color="secondary"
                            text-color="white">{{ revisionTag }}
                    </v-chip>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title v-if="revision.Update_Note">

                    <v-chip color="info" text-color="blue-grey darken-2" outline>
                      <v-icon left>info</v-icon>
                      {{ revision.Update_Note }}
                    </v-chip>
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action class="hidden-sm-and-down">
                  <v-list-tile-action-text>{{ revision.revision }}</v-list-tile-action-text>
                </v-list-tile-action>

              </v-list-tile>
              <v-divider
                v-if="index + 1 < entity.revisions.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-container>
    </v-layout>
</v-container>
</template>

<script>
import axios from 'axios';
import Config from '../utils/Config';
import _ from 'underscore';
import AmplifyStore from '../store/store';

export default {
  data() {
    return {
      valid: true,
      validTestInput: false,
      testInput: '',
      entity: {
        Entity_Name: '',
        Update_Note: '',
        Tags: [],
        Event_Regex: null,
        Search_Query: '',
        Chinese_String: [],
        Latin_Replacement: '',
        Searchname: '',
        Ubermetrics_Account_Id: null,
        Ubermetrics_Search_Id: null,
        Industry_1: null,
        Industry_2: null,
        Industry_Final: null,
        Industries_Austria: [],     
        Industries_Switzerland: null,                      
        Country_Code: null,
        revisions: [],
        Entity_Status: null,
        Kununu_Links: null,
        Twitter_Authors: null,        
      },
      text: '',
      snackbar: false,
      search: null,
      ubermetricsSearchSelect: null,
      ubermetricsSearches: [],
      Regex_for_Processing: null,
      Regex_from_Ubermetrics_search: null,
      Pattern_Definitions: null,
      Additional_AND_NOTs_for_Reprocessings: null,
      eventRegexTypes: [],
      possibleTags: Config.ENTITY_TAGS,
      industries_1: Config.INDUSTRIES_1,
      industries_2: Config.INDUSTRIES_2,
      industries_final: Config.INDUSTRIES_FINAL,
      industries_austria: Config.INDUSTRIES_AUSTRIA,     
      industries_switzerland: Config.INDUSTRIES_SWITZERLAND.sort(),               
      countryCodes: Config.COUNTRY_CODES_ENTITIES.sort(),
      ubermetricsSearchRules: [
        v => !!v ||
          !!this.entity.Ubermetrics_Account_Id ||
          !!this.entity.Account_for_Processing ||
          'Please specify a Source Search',
      ],
    };
  },
  mounted() {
    const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken;
    axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;

    this.$emit('TriggerLoading', true);
    axios.get(`${Config.API_URL}/entity/${this.$route.params.uuid}`).then(response => {
      console.info(response.data);
      this.entity = response.data;
      this.entity.Update_Note = '';

      

      return axios.get(`${Config.API_URL}/event_regex`)
        .then(response => {
          this.$emit('TriggerLoading', false)
          this.eventRegexTypes = response.data.regexes;
        })
        .catch(error => {
          console.log(error)
          this.$emit('TriggerLoading', false)
        });
    }).catch(error => {
      this.$emit('TriggerLoading', false)
      console.log(error);
      this.errored = true;
    });
  },
  watch: {
    search(query) {
      if (query && (!this.ubermetricsSearchSelect || this.ubermetricsSearchSelect.text !== query)) {
        this.querySearch(query);
      }
    },

    'testInput': function (newValue, oldValue) {
      clearTimeout(this.validatationTimeout);

      this.validatationTimeout = setTimeout(() => {
        let payload = {
          Search_in_Ubermetrics: this.entity.Search_Query,
          test_input: this.testInput,
        };
        this.validTestInput = false;
        this.$emit('TriggerLoading', true);        
        let base64Payload = Buffer.from(JSON.stringify(payload)).toString('base64');
        axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Payload,helpertype:'run_regex'}).then(response => {    
          this.validTestInput = response.data.Match_available;
          this.$emit('TriggerLoading', false);          
        }).catch(error => {
          console.log(error);
          this.text = error;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);      
        });
      }, 1000);
    },
    'entity.Search_Query': _.debounce(
      function (newValue, oldValue) {

        let base64Search = Buffer.from(newValue).toString('base64');
          axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Search,helpertype:'searchformat'})        
          .then(response => {
          this.Regex_for_Processing = response.data.Regex_for_Processing;
          this.Regex_from_Ubermetrics_search = response.data.Regex_from_Ubermetrics_search;
          this.Pattern_Definitions = response.data.Pattern_Definitions;
        }).catch(error => {
          console.log(error);
          this.errored = true;
        });
      },
      500,
    ),
  },
  computed: {
    progress() {
      return (this.validTestInput ? 100 : 100);
    },
    testInputColor() {
      return (this.validTestInput ? 'success' : 'error');
    },
    chineseStringDisplay: {
      get() {
        return Array.isArray(this.entity.Chinese_String) ? this.entity.Chinese_String.join(', ') : '';
      },
      set(value) {
        this.entity.Chinese_String = value ? value.split(',').map(s => s.trim()).filter(s => s.length > 0) : [];
      }
    },
    ubermetricsAccount() {

      if (this.entity.Account_Search_Ids_New.length === 0) {
        return null;
      }

      return "not null";
    },
  },
  methods: {
    querySearch: _.debounce(
      function querySearch(query) {

        this.$emit('TriggerLoading', true)

        axios.get(`${Config.API_URL}/ubermetrics-searches?query=${query}`).then(response => {
          this.ubermetricsSearches = _.map(response.data, function (umsearch) {
            return _.extend(
              {
                Detail_Info: `${umsearch.Name} (Account/Search: ${umsearch.Account_Id}/${umsearch.Search_Id}, Active: ${umsearch.Ubermetrics_Search_Status}, Type: ${umsearch.Search_Type})`,
              },
              umsearch);
          });
          this.$emit('TriggerLoading', false)
        }).catch(error => {
          console.error(error);
          this.errored = true;
        });
      },
      500,
    ),
    'cancel': function () {
      this.$router.go(-1);
    },
     addField(value, fieldType) {
      fieldType.push("");
      },
     removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },
    'submit': function () {

      if (this.$refs.form.validate()) {

        if (this.ubermetricsSearchSelect) {
          this.entity.Account_Search_Ids.push(this.ubermetricsSearchSelect);
        }

        for (var list_index = 0; list_index < this.entity.Account_Search_Ids_New.length; list_index++) {
        if (this.entity.Account_Search_Ids_New[list_index].remove === true) {const index = this.entity.Account_Search_Ids.indexOf(this.entity.Account_Search_Ids_New[list_index].value);
        if (index > -1) {
        this.entity.Account_Search_Ids.splice(index, 1); 
        }}}
        
        let entityPayload = {...this.$data.entity};
        entityPayload.revisions = null;

        this.$emit('TriggerLoading', true);

        axios.put(`${Config.API_URL}/entity/${this.$route.params.uuid}`, entityPayload).then(response => {
          console.info(response.data);
          this.text = response.data.message;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);
        }).catch(error => {
          this.text = error.response.data.message;
          this.errored = true;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);
        });
      }

    },
  },
};
</script>

